import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_580_3403)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9 18C10.78 18 12.5201 17.4722 14.0001 16.4832C15.4802 15.4943 16.6337 14.0887 17.3149 12.4442C17.9961 10.7996 18.1743 8.99002 17.8271 7.24419C17.4798 5.49836 16.6226 3.89472 15.364 2.63604C14.1053 1.37737 12.5016 0.520204 10.7558 0.172937C9.00998 -0.17433 7.20038 0.00389957 5.55585 0.685088C3.91131 1.36628 2.50571 2.51983 1.51677 3.99987C0.527841 5.47991 0 7.21997 0 9C0 11.387 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM4.5 8.25H8.0625C8.11223 8.25 8.15992 8.23025 8.19508 8.19509C8.23025 8.15992 8.25 8.11223 8.25 8.0625V4.5C8.25 4.30109 8.32902 4.11033 8.46967 3.96967C8.61032 3.82902 8.80109 3.75 9 3.75C9.19891 3.75 9.38968 3.82902 9.53033 3.96967C9.67098 4.11033 9.75 4.30109 9.75 4.5V8.0625C9.75 8.11223 9.76976 8.15992 9.80492 8.19509C9.84008 8.23025 9.88777 8.25 9.9375 8.25H13.5C13.6989 8.25 13.8897 8.32902 14.0303 8.46967C14.171 8.61033 14.25 8.80109 14.25 9C14.25 9.19892 14.171 9.38968 14.0303 9.53033C13.8897 9.67099 13.6989 9.75 13.5 9.75H9.9375C9.88777 9.75 9.84008 9.76976 9.80492 9.80492C9.76976 9.84009 9.75 9.88778 9.75 9.9375V13.5C9.75 13.6989 9.67098 13.8897 9.53033 14.0303C9.38968 14.171 9.19891 14.25 9 14.25C8.80109 14.25 8.61032 14.171 8.46967 14.0303C8.32902 13.8897 8.25 13.6989 8.25 13.5V9.9375C8.25 9.88778 8.23025 9.84009 8.19508 9.80492C8.15992 9.76976 8.11223 9.75 8.0625 9.75H4.5C4.30109 9.75 4.11032 9.67099 3.96967 9.53033C3.82902 9.38968 3.75 9.19892 3.75 9C3.75 8.80109 3.82902 8.61033 3.96967 8.46967C4.11032 8.32902 4.30109 8.25 4.5 8.25Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_580_3403" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "18",
      height: "18",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'addIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  size: {
    type: Number as PropType<number>,
    default: 18,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})